import React from "react";
import Layout from "../../Layout";
import HeaderReports from "../HeaderReports";
import ListDownloadStatus from "./ListDownloadStatus";

const DownloadStatus = () => {

  return (
    <Layout>
      <HeaderReports />
      <ListDownloadStatus />
    </Layout>
  );
};


export default DownloadStatus;
